<template>
    <v-btn        
        text
        v-on:click="logOut"
      >
        <span class="mr-2 primary--text">Logout</span>
        <v-icon color="primary">mdi-logout</v-icon>
      </v-btn>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
    methods: {
        ...mapActions({
            signOut: 'auth/signOut'
        }),

        ...mapMutations({
            setOverlay: 'auth/setOverlay',            
        }),

        async logOut () {            
            try{
                this.setOverlay(true);            
                await this.signOut();
                sessionStorage.clear();
            } catch (error) {
                error.response ? console.log(error.response) : error
            } finally{
                this.setOverlay(false);
                this.$router.replace('/')
            }
        }

        
    }
}
</script>